import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert } from './models/alert';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private _alert = new Subject<Alert>();
  alert$ = this._alert.asObservable();

  constructor(private toastr: ToastrService) {
    // Trigger toast/snackbar when alert is received.
    this.alert$.subscribe((alert) => {
      /* eslint-disable indent */
      switch (alert.type) {
        case 'error':
          this.toastr.error(alert.message);
          break;
        case 'warning':
          this.toastr.warning(alert.message);
          break;
        case 'info':
          this.toastr.success(alert.message);
          break;
        default:
          break;
      }
    });
  }

  setAlert(alert: Alert): void {
    this._alert.next(alert);
  }
}
